module.exports = __webpack_public_path__ + "static/media/arrow_upward_off.718c92ea.svg";